import type { GamePageEvent } from "@/context/AnalyticsProvider/gamePage";

export interface GPOnboardingStepProps {
  onNext: (increment?: number) => void;
  isVisible: boolean;
  track: (event: GamePageEvent) => void;
}

export enum GPOnboardingStep {
  LOGIN = "login",
  BRONZE_REWARD_ACHIEVED = "bronze-reward-achieved",
  LINK_STEAM = "link-steam",
  SILVER_REWARD_ACHIEVED = "silver-reward-achieved",
  WISHLIST_STEAM = "wishlist-steam",
  WISHLIST_STEAM_VERIFY = "wishlist-steam-verify",
  FOLLOW_ON_X = "follow-on-x",
  GOLD_REWARD_ACHIEVED = "gold-reward-achieved",
}

// Set by ?testId= query param
export enum GPExperimentType {
  EXTRINSIC = "ExtrinsicRewards",
  HYBRID = "HybridRewards",
  INGAME = "In-GameRewards",
  NO_PROMPT = "NoPrompt",
}

// For backward compatibility with utm_content query param
export enum GPOnboardingTypeUTM {
  EXTRINSIC = "25-11-27_ExtrinsicRewards_Acq-Broad_8-Ball_Leads_All-Placements",
  HYBRID = "25-11-27_HybridRewards_Acq-Broad_8-Ball_Leads_All-Placements",
  INGAME = "25-11-27_In-GameRewards_Acq-Broad_8-Ball_Leads_All-Placements",
  NO_PROMPT = "25-11-27_NoPrompt_Acq-Broad_8-Ball_Leads_All-Placements",
}
// Map UTM values to standard experiment values
const utmTypeMap: Record<GPOnboardingTypeUTM, GPExperimentType> = {
  [GPOnboardingTypeUTM.EXTRINSIC]: GPExperimentType.EXTRINSIC,
  [GPOnboardingTypeUTM.HYBRID]: GPExperimentType.HYBRID,
  [GPOnboardingTypeUTM.INGAME]: GPExperimentType.INGAME,
  [GPOnboardingTypeUTM.NO_PROMPT]: GPExperimentType.NO_PROMPT,
};

/**
 * Gets the experiment type from search params, with legacy support for utm_content
 */
export function getExperimentTypeFromSearchParams(
  searchParams: URLSearchParams | null,
): GPExperimentType | undefined {
  if (!searchParams) return undefined;

  // Prefer testId query param
  const testId = searchParams.get("testId");
  if (testId) {
    const type = Object.values(GPExperimentType).find(
      (value) => value === testId,
    );
    if (type) return type;
  }

  // Fallback to utm_content
  const utmContent = searchParams.get("utm_content");
  if (utmContent) {
    const utmType = Object.values(GPOnboardingTypeUTM).find(
      (value) => value === utmContent,
    ) as GPOnboardingTypeUTM | undefined;
    if (utmType) {
      return utmTypeMap[utmType];
    }
  }

  return undefined;
}
